module.exports = __webpack_public_path__ + "static/media/game.483b05d9.png";